export default {
  disabled: {
    title: 'Die Abrechnung läuft nicht über die Plattform',
    description:
      'Abonnements und Rechnungen sind nicht verfügbar, da die Abrechnung zwischen dir und deinen Restaurants außerhalb der Plattform erfolgt. Auszahlungen, Abrechnungen und Berichte bleiben verfügbar.',
  },
};
